module.exports = __webpack_public_path__ + "img/members-club.198ef97f.webp";